import { getShortUrlSource } from "@/modules/tracking/utils/getShortUrlSource";

export const readSourceFromLocation = () => {
  if (typeof window === "undefined") return getShortUrlSource(null);
  return getShortUrlSource(window.location.search);
};
